
export enum SlotStep {
  FighterSel = 0,
  TeamSel = 1,
  Ready = 2
}
